import { submitReferralCodeApi } from 'api/client';
import { REFERRAL_CODE_API_FAIL_REASON, REFERRAL_CODE_REASON } from 'client/utils/referralCode';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { setReferralCodeInput } from 'client/redux/modules/userEntryState';
import { setReferralCodeStatus } from 'client/redux/modules/promoState';
import { useCallback } from 'react';
import useClientErrorHandler, { generateApiErrObj } from 'client/hooks/useClientErrorHandler';
import * as clientErrTypes from 'config/clientErrorTypes';
import { setNotQualifiedType } from 'client/redux/modules/userLoginState';

export default function useSubmitReferralCode() {
    const referralCode = useSelector(s => s.promoState.referralCode);
    const enableReferralCodeRequired = useSelector(
        s => s.settingMGMReferral.enableReferralCodeRequired
    );
    const entryUuid = useSelector(s => s.userEntryState.currentEntryUUID);
    const promoUuid = useSelector(s => s.promo.uuid);
    const dispatch = useDispatch();
    const errHandler = useClientErrorHandler();

    const handleSubmit = useCallback(
        async code => {
            const submitCode = code || referralCode;

            if (submitCode) {
                Cookies.remove('ref_code');
                try {
                    const submitResp = await submitReferralCodeApi({
                        promoUuid,
                        entryUuid,
                        referralCode: submitCode
                    });

                    if (submitResp.httpStatus === 200) {
                        dispatch(setReferralCodeInput(true));
                        dispatch(
                            setReferralCodeStatus({
                                referralCode: ''
                            })
                        );
                        dispatch(setNotQualifiedType(''));

                        return {
                            success: true
                        };
                    } else if (
                        submitResp?.payload?.message ===
                        REFERRAL_CODE_API_FAIL_REASON.REFERRAL_CODE_NOT_FOUND
                    ) {
                        // 邀請碼錯誤
                        dispatch(
                            setReferralCodeStatus({
                                referralCode: ''
                            })
                        );

                        return {
                            success: false,
                            reason: REFERRAL_CODE_API_FAIL_REASON.REFERRAL_CODE_NOT_FOUND,
                            error: submitResp
                        };
                    } else if (
                        submitResp?.payload?.message ===
                        REFERRAL_CODE_API_FAIL_REASON.CAN_NOT_USE_SELF_REFERRAL_CODE
                    ) {
                        // 邀請碼錯誤
                        dispatch(
                            setReferralCodeStatus({
                                referralCode: ''
                            })
                        );

                        return {
                            success: false,
                            reason: REFERRAL_CODE_API_FAIL_REASON.CAN_NOT_USE_SELF_REFERRAL_CODE,
                            error: submitResp
                        };
                    } else {
                        throw generateApiErrObj(
                            submitResp,
                            clientErrTypes.SUBMIT_REFERRIAL_CODE_FAILED
                        );
                    }
                } catch (err) {
                    dispatch(
                        setReferralCodeStatus({
                            referralCode: ''
                        })
                    );

                    errHandler({ err });
                }
            } else {
                // 失敗
                dispatch(
                    setReferralCodeStatus({
                        referralCode: ''
                    })
                );

                return {
                    success: false,
                    reason: REFERRAL_CODE_REASON.GET_EMPTY_REFERRAL_CODE
                };
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [enableReferralCodeRequired, referralCode]
    );

    return handleSubmit;
}
